// InvoiceTotals.js -
import React from 'react';
import { useTranslation } from 'react-i18next';

const InvoiceTotals = ({ currency, subTotal, discountRate, discountAmount, taxRate, taxAmount, total }) => {
  const { t } = useTranslation();

  const showDiscount = discountRate && parseFloat(discountRate) !== 0;

  return (
    <div className="d-flex flex-column align-items-end">
      <div className="d-flex flex-row align-items-start justify-content-between w-100 mb-2">
        <span className="fw-bold">{t('subtotal')}</span>
        <span>{currency}{subTotal}</span>
      </div>
      
      {/* CONDITIONAL: Only show discount if discountRate != 0 */}
      {showDiscount && (
        <div className="d-flex flex-row align-items-start justify-content-between w-100 mb-2">
          <span className="fw-bold">{t('discountAmount', { rate: discountRate })}</span>
          <span>{currency}{discountAmount}</span>
        </div>
      )}
      
      <div className="d-flex flex-row align-items-start justify-content-between w-100 mb-2">
        <span className="fw-bold">{t('taxAmount', { rate: taxRate || '0.00' })}</span>
        <span>{currency}{taxAmount}</span>
      </div>
      
      <hr className="w-100 my-2" />
      <div className="d-flex flex-row align-items-start justify-content-between w-100">
        <span className="fw-bold fs-5">{t('total')}</span>
        <span className="fw-bold fs-5">{currency}{total}</span>
      </div>
    </div>
  );
};

export default InvoiceTotals;